
import './TodosError.css';
function TodosError(){
    
    
    return (
      <div>
        Se ha producido un error al cargar
      </div>
      
    );
}
export { TodosError };